"use client";
import React, { useEffect, useState } from 'react';
import Link from "next/link";

const Counter = ({ endValue, duration }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startValue = 0;
    const stepTime = (duration * 1000) / endValue; // Convert to milliseconds

    const counter = setInterval(() => {
      setCount((prevCount) => {
        if (prevCount < endValue) {
          return prevCount + 1;
        } else {
          clearInterval(counter);
          return endValue;
        }
      });
    }, stepTime);

    return () => clearInterval(counter);
  }, [endValue, duration]);

  return <span>{count} +</span>;
};

const ABoutUsBanner = () => {
  return (
    <div className="about_banner_section">
      <div className="container">
        <div className="common_title_allaboutus1">
          <p className="aboutusbanner_hd">What We Do</p>
          {/* <p className="aboutusbanner_cont">
            With over a decade of experience and a proven track record of successfully completing <br />
            over 310 projects, S.S. White Technologies is a dedicated provider of tailored solutions <br />
            that perfectly match our client's unique needs.
          </p> */}
        </div>
        <div className="common_title_allaboutus">
          <div className="home_linksbtn home_linksbtnouter">
            <Link href="/careers" className="btn btn-secondary" aria-label="Join our team">
              Join our team <span className="bannerbutton_arrow"></span>
            </Link>
          </div>
          {/* <div className="completed_task">
            <div>
              <label>
                <Counter endValue={20} duration={2} />
              </label>
              <small>PRESTIGIOUS AWARDS</small>
            </div>
            <div>
              <label>
                <Counter endValue={100} duration={2} />
              </label>
              <small>COMPLETED PROJECTS</small>
            </div>
            <div>
              <label>
                <Counter endValue={99} duration={2} />
              </label>
              <small>HAPPY CLIENTS</small>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ABoutUsBanner;
